/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoveOrderLinesDto
 */
export interface MoveOrderLinesDto {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MoveOrderLinesDto
     */
    orderLineQuantityMap: { [key: string]: number; };
}

/**
 * Check if a given object implements the MoveOrderLinesDto interface.
 */
export function instanceOfMoveOrderLinesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderLineQuantityMap" in value;

    return isInstance;
}

export function MoveOrderLinesDtoFromJSON(json: any): MoveOrderLinesDto {
    return MoveOrderLinesDtoFromJSONTyped(json, false);
}

export function MoveOrderLinesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoveOrderLinesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderLineQuantityMap': json['orderLineQuantityMap'],
    };
}

export function MoveOrderLinesDtoToJSON(value?: MoveOrderLinesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderLineQuantityMap': value.orderLineQuantityMap,
    };
}

